import Modal from "react-bootstrap/Modal";
import { useState } from "react";
import SrvButton from "../../../components/global/SrvButton";
import axios from "axios";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ErrorAdd from "../../../util/ErrorAdd";

function CompanyModalArchive({ show, onHide, onHideLabel, idCompany, name }) {

    const [log, setLog] = useState(null);
    const [loading, setLoading] = useState(false);

    function removeHandler() {
        setLoading(true);

        axios.post('/api_main/company/statusSet', { ID: idCompany, ID_Status: 0 })
            .then((res) => {
                if (res.data.Status === 1) {
                    setLoading(false);
                    onHide();
                    onHideLabel();
                }
                else {
                    setLoading(false);
                    setLog(res.data.Error);
                }
            })
            .catch((err) => {
                setLog('Неизвестная ошибка!');
                setLoading(false);
                ErrorAdd(err, window.location.href);
            });
    }

    return (
        <>
            <Modal show={show} onHide={onHide}>
                <Modal.Body>
                    <div className="modal_close" onClick={onHide}><FontAwesomeIcon icon={faXmark} className="opacity-50" /></div>
                    <div className="modal_title text-center mb-20">Архивирование компании</div>

                    <div className="text-center">Подтвердите архивирование компании
                        <br></br>
                        <div className="badge" style={{ marginTop: "6px" }}>{name}</div>
                    </div>
                    {log !== null && <div className="form_error text-center">{log}</div>}
                    <div className="row">
                        <div className="col-md-12 text-center">
                            <SrvButton typeBtn="archive" loading={loading} size={'lg'} onClick={() => removeHandler()} />
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}
export default CompanyModalArchive;
